import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconArrowTriangleRight"><Path d="M5.08541 4.07918C4.85292 3.96293 4.57681 3.97536 4.3557 4.11201C4.13459 4.24867 4 4.49007 4 4.75V19.25C4 19.5099 4.13459 19.7513 4.3557 19.888C4.57681 20.0246 4.85292 20.0371 5.08541 19.9208L19.5854 12.6708C19.8395 12.5438 20 12.2841 20 12C20 11.7159 19.8395 11.4562 19.5854 11.3292L5.08541 4.07918Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleRight;
